export default __webpack_public_path__ + "static/media/card-futuristic-tartiary.e77e6f0e.svg";